<template>
  <ClientOnly>
    <div class="space-y-3" v-if="status === 'success'">
      <div class="font-heading font-bold text-2xl" v-html="$t('shared.nav.leagues')" />
      <div v-for="league in data.leagues" :key="`league-${league.id}`" class="border rounded-md">
        <NuxtLink :to="{ name: 'leagues-league', params: { league: league.slug }}" @click="closeDrawer()" class="p-2 block">
          <div class="flex items-center gap-3">
            <LeagueLogo class="w-12 aspect-square rounded-md overflow-hidden" :name="league.name" :slug="league.slug" />
            <div>
              <div class="font-bold">{{ league.name }}</div>
              <div class="text-sm text-slate-500">{{ league.season.year }}</div>
            </div>
            <div class="ml-auto text-sky-600 p-1">
              <AtomIcon name="chevron-circle-right" class="text-lg" />
            </div>
          </div>
        </NuxtLink>
      </div>
    </div>
  </ClientOnly>
</template>

<script setup>
const { closeDrawer } = useAppDrawer()

// Fetch leagues (client only)
const { data, status } = await useFetch('/api/v1/leagues', { 
  key: 'leagues',
  baseURL: useEnv('apiBase'),
  server: false,
})
</script>